import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import internacional from '@/stores/modules/internacional.js'
import novedades from '@/stores/modules/novedades.js'
import inversedLogistic from '@/stores/modules/inversedLogistic.js'
import cotizar from '@/stores/modules/cotizar.js'
import userProfile from '@/stores/modules/userProfile.js'
import geoLocation from '@/stores/modules/geoLocation.js'
import global from '@/stores/modules/global.js'
import news from '@/stores/modules/news.js'
// import createMutationsSharer from 'vuex-shared-mutations'

import auth from '@/stores/modules/auth'
import * as actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  modules: {
    auth,
    internacional,
    novedades,
    inversedLogistic,
    cotizar,
    userProfile,
    geoLocation,
    global,
    news
  },
  plugins:
    [
      createPersistedState({ paths: ['auth', 'global'] })
      // createMutationsSharer({ predicate: ['ADD_CART_PRODUCT', 'REMOVE_CART_PRODUCT', 'CLEAR_CART', 'CHANGE_QUANTITY_CART_PRODUCT', 'SET_CART_TOTALS'] })
    ]
})
